import { createFileRoute } from '@tanstack/react-router'
import { CookiePreferencesPage } from '@/features/settings/components/CookiePreferencesPage'

export const Route = createFileRoute('/_authed/settings/cookies')({
  component: CookiePreferencesPage,
})
